import { ControlButton } from '@/UIComponents2/ControlButton'
import { cn } from '@/utlis/cn'
import React from 'react'

export const overlayBgClasses = 'bg-black/20 hover:bg-black/40 backdrop-blur-[8px] group-hover:opacity-100'

type OverlayControlButtonProps = {
    className?: string
    onClick?: () => void
    onMouseDown?: (event: React.MouseEvent<HTMLButtonElement>) => void
    children?: React.ReactNode
}
export const OverlayControlButton = React.forwardRef<HTMLButtonElement, OverlayControlButtonProps>((props, ref) => {
    return (
        <ControlButton
            ref={ref}
            onClick={props.onClick}
            variant="glow"
            className={cn(overlayBgClasses, 'aspect-square h-[36px]', props.className)}
            onMouseDown={props.onMouseDown}
        >
            {props.children}
        </ControlButton>
    )
})
